import {addCodeToPhone} from "@/utils/phone-utils";
import {Brochure} from "@/types/dto/common/brochure";

const customerLeadBrochureInfoFactory = (
  brochures: Brochure[]
): { brochureName: string; brochureQuantity: number }[] =>
  brochures.reduce((acc, cur) => {
    // Check if item already exists
    const existing = acc.find(item => item.brochureName === cur.brochureName);

    if (existing) {
      // increment quantity
      existing.brochureQuantity += 1;
    } else {
      // create new item
      acc.push({
        brochureName: cur.brochureName,
        brochureQuantity: cur?.brochureQuantity ?? 1 // default to 1 if not provided
      });
    }

    return acc;
  }, [] as { brochureName: string; brochureQuantity: number }[]);

const rabDataLayerPushFactory = (data?: any, sourceUrl?: string, isAgent?: string) => ({
  event: "dataLayerPush",
  isAgent: isAgent ?? "",
  formData: {
    Location: sourceUrl ?? "",
    Type: "RAB",
    Id:"",
    Name: "Brochure Mail Request",
    firstname: data?.firstName ?? "",
    lastname: data?.lastName ?? "",
    email: data?.email ?? "",
    phone: data?.phone ? addCodeToPhone(data?.countryCode?.callingCode, data?.phone) : "",
    address: data?.address ?? "",
    address_2: data?.address2 ?? "",
    city: data?.city ?? "",
    state: data?.state ?? "",
    country: data?.country ?? "",
    zip: data?.zipCode ?? "",
    optInEmail: data?.optInEmail?.toString() ?? "",
    "yes i am a travel professional": data?.isTravelAgent?.toString() ?? "",
    "yes i am traveling with 8 or more people": data?.withMoreTravelers?.toString() ?? "",
    brochures: Array.isArray(data?.customerLeadBrochures)
      ? customerLeadBrochureInfoFactory(data?.customerLeadBrochures)
      : null
  }
});

export default rabDataLayerPushFactory;